import { createAsyncThunk } from '@reduxjs/toolkit';
import { resetEnableUpsellByCheckout } from '../operations';
import getCurrentOrder from '../selectors/getCurrentOrder';
import getStagedPurchases from '../selectors/getStagedPurchases';
import { setStagedPurchases } from '../reducers/currentOrder/stagedPurchases';
import { stagedPurchaseContainsAlcoholicItems } from '../utils/ordering/filterAlcoholic';

export const removeAlcoholicItemsFromCart = createAsyncThunk(
  'removeAlcoholicItemsFromCart',
  async (_data: undefined, { dispatch, getState, rejectWithValue }) => {
    try {
      const state = getState() as EntireFrontendState;

      const alcoholicPurchaseIds = new Set(
        getStagedPurchases(state)
          .filter(purchase => stagedPurchaseContainsAlcoholicItems(purchase))
          .map(purchase => purchase.id),
      );

      const cartHasAlcoholicItems = alcoholicPurchaseIds.size > 0;

      if (!cartHasAlcoholicItems) return false;

      const stagedPurchases = getCurrentOrder(state).stagedPurchases.filter(
        purchase => !alcoholicPurchaseIds.has(purchase.id),
      );
      const cartIsEmpty = stagedPurchases.length === 0;

      dispatch(setStagedPurchases(stagedPurchases));

      if (cartIsEmpty) dispatch(resetEnableUpsellByCheckout(true));

      return true;
    } catch (e) {
      console.error('Remove alcoholic staged purchases error:', { e });
      return rejectWithValue(e);
    }
  },
);
